module.exports = __webpack_public_path__ + "de38ca42442d28b1804eb103e07f7daf.woff2";